"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var base_1 = require("./base");
exports.Annotation = base_1.default;
var line_1 = require("./line");
exports.Line = line_1.default;
var text_1 = require("./text");
exports.Text = text_1.default;
var arc_1 = require("./arc");
exports.Arc = arc_1.default;
var region_1 = require("./region");
exports.Region = region_1.default;
var image_1 = require("./image");
exports.Image = image_1.default;
var html_1 = require("./html");
exports.Html = html_1.default;
var data_marker_1 = require("./data-marker");
exports.DataMarker = data_marker_1.default;
var data_region_1 = require("./data-region");
exports.DataRegion = data_region_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/component/lib/annotation/index.js
// module id = 763
// module chunks = 37